import { ApiType } from "@gymflow/common";
import { useInfiniteQuery } from "@tanstack/react-query";

import { creditPackAsMemberQueryKeys } from "./creditPackAsMemberQueryKeys";

export const useInfiniteQuerySessionPackSubscriptionUsageHistoryAsMember = ({
  api,
  subscriptionId,
  enabled,
}: {
  api: ApiType;
  subscriptionId: number;
  enabled: boolean;
}) =>
  useInfiniteQuery({
    queryKey:
      creditPackAsMemberQueryKeys.sessionPackSubscriptionUsageHistoryAsMember(
        subscriptionId,
      ),
    queryFn: async ({ pageParam }: { pageParam?: string }) =>
      (
        await api.customerCreditPackApi.sessionPackSubscriptionUsageHistory({
          subscriptionId,
          nextPageToken: pageParam,
        })
      ).data,
    getNextPageParam: (lastPage) => lastPage?.nextPageToken,
    enabled,
    initialPageParam: undefined,
  });
